export enum M365ThemeKind {
    FabricDefaultTheme,
    M365Dark,
    M365Light,
    M365LightWithContrast,
    TeamsLight,
    TeamsDark,
  }
